import {getConfig} from 'config';
import {getData} from '../dataProvider';

export const loadInfoTabSections = infoTabTitle => {
  return getData(`${getConfig('infoTabSectionsUrl')}/${infoTabTitle}`);
};
